



































import { Component, Prop, Vue } from "vue-property-decorator";

interface Post {
  uid: string
  title: string
  content: string
  createdAt: string
  tags: Array<string>
  image: string
}

@Component
export default class SignupComponent extends Vue {
  @Prop()
	private msg!: string;
	private signinStatus = "signed out"

	private mailaddress: string = '?'
	private password: string = '?'

	created () {
		//this.queryProc2()
		const user = this.$auth.currentUser
		if (user) {
			// User is signed in.
			const email = user.email
			const uid = user.uid
			this.signinStatus = "signed in"
			//this.$watanabe = uid
			//window.console.log("created() 2.User is signed in: ")
			//window.console.log("created() 3.uid: " + uid)
			//window.console.log("created() 4.email: " + email)
		} else {
			// No user is signed in.
			//this.$watanabe = "sign out"
			this.signinStatus = "signed out"
			window.console.log("created() 5.No user is signed in: ")
			// 単純な遷移
			this.$router.push('/signin/')
		}
	}

	public signUp() {
		window.console.log("signup() 1.");
		window.alert('まだサポートしておりません。')
		/*
		this.$auth.createUserWithEmailAndPassword(this.mailaddress, this.password)
		.then(
			// 成功時の処理
		)
		.catch(
			// エラー時の処理 
		)
		*/
	}

} // end of export
